var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { LotteryInsurance } from "./lottery-insurance";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { LotteryPlatformClaims } from "../../../../../constants/modules/lotteryplatform.claims";
import 'print-this';
var LotteryInsurancePrint = /** @class */ (function (_super) {
    __extends(LotteryInsurancePrint, _super);
    function LotteryInsurancePrint(notificationService, i18N, userClaimsService, lookupService, signaler) {
        var _this = _super.call(this, notificationService, i18N, lookupService, signaler) || this;
        _this.userClaimsService = userClaimsService;
        _this.showAllCosts = false;
        _this.canShowAllCosts = false;
        _this.cdnImages = __CDN_IMAGES__;
        return _this;
    }
    LotteryInsurancePrint.prototype.getTiersInsured = function (lottery) {
        var e_1, _a;
        var operatorPolicies = null;
        var lotteryPriceTiers = Enumerable.from(lottery.lotteryPriceTiers).select(function (x) { return x.lotteryPriceTierId; }).toArray();
        if (this.insuranceDataHandler.operatorPoliciesApplied) {
            operatorPolicies = Enumerable.from(this.insuranceDataHandler.operatorPoliciesApplied).where(function (x) { return x.isActive && Enumerable.from(lotteryPriceTiers).any(function (t) { return t == x.lotteryPriceTierId; }); });
        }
        var brandAppliedPolicies = Enumerable.from(this.item.lotteryPriceTierInsurancePolicies).where(function (x) { return x.isActive; });
        var insuredTiers = [];
        var _loop_1 = function (tier) {
            var brandPolicyForTier = brandAppliedPolicies.firstOrDefault(function (x) { return x.lotteryPriceTierId == tier.lotteryPriceTierId; });
            if (brandPolicyForTier) {
                //then only add it if should insure is true
                if (brandPolicyForTier.shouldInsure) {
                    insuredTiers.push(tier);
                }
            }
            else if (operatorPolicies) {
                //if we didn't find one at brand level then lets check at operator level
                var operatorPolicy = operatorPolicies.firstOrDefault(function (x) { return x.lotteryPriceTierId == tier.lotteryPriceTierId; });
                if (operatorPolicy && operatorPolicy.shouldInsure) {
                    insuredTiers.push(tier);
                }
            }
        };
        try {
            for (var _b = __values(lottery.lotteryPriceTiers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tier = _c.value;
                _loop_1(tier);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return insuredTiers.length == 0 ? "No Tiers" : Enumerable.from(insuredTiers).select(function (x) { return x.name; }).toArray().join(", ");
    };
    LotteryInsurancePrint.prototype.onActivated = function () {
        var _this = this;
        this.insuranceDataHandler.loadInsuranceData(this.item).then(function (x) {
            _this.onActivatedCompleted();
        });
    };
    LotteryInsurancePrint.prototype.onActivatedCompleted = function () {
        this.canShowAllCosts = this.userClaimsService.hasPermission(LotteryPlatformClaims.ShowAllCosts);
    };
    LotteryInsurancePrint.prototype.print = function () {
        var containerClass = '.page-lottery-insurance';
        $(containerClass).printThis({
            importStyle: true
        });
    };
    LotteryInsurancePrint.prototype.onEnter = function (event) {
        if (event.detail && event.detail.keyCode == 13) {
            this.signaler.signal('refreshLotteryPrices');
        }
        else if (event.detail && event.detail.keyCode == 8 && !this.searchQuery) {
            this.signaler.signal('refreshLotteryPrices');
        }
    };
    LotteryInsurancePrint.prototype.showInsuranceHandler = function (lottery) {
        if (this.searchQuery) {
            var searchResultNum = lottery.name.toLowerCase().includes(this.searchQuery.toLowerCase());
            if (searchResultNum)
                return true;
            return false;
        }
        else
            return true;
    };
    LotteryInsurancePrint = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, UserClaimsService,
            LookupClientService, BindingSignaler])
    ], LotteryInsurancePrint);
    return LotteryInsurancePrint;
}(LotteryInsurance));
export { LotteryInsurancePrint };
